module.exports = __webpack_public_path__ + "img/gem6_color2.e4f5d949.png";